<template>
  <div>
    <!--HTML related information for displaying the component-->
    <template>
      <div>Pivot</div>
    </template>
  </div>
</template> 

<!--JavaScript related information for the component's logic-->
<script>
import Flexmonster from "flexmonster";
export default /*#__PURE__*/ {
  name: "Pivot", // vue component name
  props: {},
  mounted: function () {
    this.flexmonster = new Flexmonster({
      container: this.$el,
      toolbar: true,
      licenseKey: "Z7RK-XEGD4F-2U0W1H-4P2G5Z-0C5W0D-6H3B5Z-2K",
      global: {
        localization: "/lang/fr.json",
      },
      /* report: {
        localization: "/lang/fr.json",
      }, */
      report: "https://cdn.flexmonster.com/github/demo-report.json",
    });
  },
  beforeUpdate() {
    return false;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "~flexmonster/flexmonster.min.css";
</style>